<template>
    <div class="BookingNav">
        <nav class="Nav">         
             <router-link class="BookingNavButton" tag="div" to="/" active-class="SelectedItem" exact ><span><a style="text-decoration:none;">Scegli <br />un Centro</a></span></router-link>
            <router-link class="BookingNavButton" tag="div" to="/BookingCalendar" active-class="SelectedItem" exact><span><a>Data</a></span></router-link>
            <router-link class="BookingNavButton" tag="div" to="/BookingForm" active-class="SelectedItem" exact :disabled="true"><span><a>Prenota</a></span></router-link> 
        </nav>
    </div>
</template>
<script>

export default({
   name: 'BookingNavigator'
})
</script>
